import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  primary?: boolean;
  className?: string;
  onClick?: () => void;
  href?: string;
  id?: string;
  trackClick?: boolean;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  primary = true,
  className = '',
  onClick,
  href,
  id,
  trackClick = false
}) => {
  const buttonClasses = `${primary ? 'bg-gradient-to-r from-[#1DB954] to-[#22C55E] text-white shadow-lg shadow-[#22C55E]/20 hover:shadow-[#22C55E]/40 border border-[#22C55E]/20' : 'bg-transparent border border-[#E0B84C] text-[#E0B84C] hover:bg-[#E0B84C]/10'} font-bold py-3 px-6 rounded-full transition-all duration-300 transform hover:scale-105 flex items-center justify-center ${className} ${trackClick ? 'cta-download' : ''}`;
  const handleClick = () => {
    if (onClick) onClick();
    if (trackClick && window.fbq) {
      window.fbq('trackCustom', 'CTA_Download_Click');
    }
  };
  if (href) {
    return <a href={href} className={buttonClasses} onClick={handleClick} id={id} data-id="element-349">
        <div className="flex items-center justify-center w-full" data-id="element-350">
          {children}
        </div>
      </a>;
  }
  return <button onClick={handleClick} className={buttonClasses} id={id} data-id="element-351">
      <div className="flex items-center justify-center w-full" data-id="element-352">{children}</div>
    </button>;
};